import styled from 'styled-components';

export const TermsInfoText = styled.span`
    display: inline-block;
    margin-top: 12px;
    font-size: 0.75rem;
    line-height: 1.4;

    & a {
        color: currentColor;
        text-decoration: underline;
    }

    & a:hover {
        text-decoration: none;
    }
`;
